import {Tabs} from "tailwindcss-stimulus-components";

export default class extends Tabs {

    static targets = ['tab', 'panel', 'submenu']


    initialize() {
        this.activeTabClasses = this.data.get('activeTab').split(' ');
        this.inactiveTabClasses = this.data.get('inactiveTab').split(' ');


        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const pTab = urlParams.get('tab')

        if (pTab !== null) {
            this.tabTargets.forEach((tab, index) => {
                if (tab.dataset.tabsId === pTab) {
                    this.index = index
                }
            })

        }
        super.initialize();
    }

    connect() {
        super.connect();
        this.loadLazyPanel(this.index);
    }

    change(event) {
        super.change(event);
        this.loadLazyPanel(this.index);
    }

    retryLazyPanel() {
        const panel = this.panelTargets[this.index];
        panel.dataset.tabsLazyState = '';
        this.loadLazyPanel(this.index);
    }

    loadLazyPanel(index) {
        const tab = this.tabTargets[index];
        const panel = this.panelTargets[index];
        const url = tab && tab.dataset.tabsLazyUrl;

        if (!url || !panel || ['loading', 'loaded'].includes(panel.dataset.tabsLazyState)) return;

        panel.dataset.tabsLazyState = 'loading';
        const label = tab.textContent.trim() || 'content';
        panel.innerHTML = `<div class="my-6 rounded-xl border border-slate-200 bg-white p-6 text-center text-sm text-slate-600" role="status">Loading ${label.toLowerCase()}…</div>`;

        fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Accept': 'text/html',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then((response) => {
                if (!response.ok) throw new Error(`Panel request failed with ${response.status}`);
                return response.text();
            })
            .then((html) => {
                panel.innerHTML = html;
                panel.dataset.tabsLazyState = 'loaded';
            })
            .catch(() => {
                panel.dataset.tabsLazyState = 'error';
                panel.innerHTML = `<div class="my-6 rounded-xl border border-red-200 bg-red-50 p-6 text-center text-sm text-red-800" role="alert">${label} could not be loaded. <button type="button" class="font-semibold underline" data-action="click->tabs#retryLazyPanel">Try again</button></div>`;
            });
    }


}
